import { motion } from "framer-motion";
import { Car, Truck, Cog, PackageSearch } from "lucide-react";

const chapters = [
  {
    n: "01",
    icon: Car,
    title: "Autodemolizione",
    text: "Centro di demolizione veicoli a Cremona. Ci occupiamo di rottamazione e pratiche di cancellazione dal PRA.",
    img: "https://images.unsplash.com/photo-1676018366904-c083ed678e60?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    span: "md:col-span-7",
  },
  {
    n: "02",
    icon: Truck,
    title: "Ritiro veicoli",
    text: "Ritiriamo auto incidentate, ferme o destinate alla demolizione. Contattaci per valutare il tuo veicolo.",
    img: "https://images.pexels.com/photos/4489758/pexels-photo-4489758.jpeg?auto=compress&cs=tinysrgb&w=800",
    span: "md:col-span-5",
  },
  {
    n: "03",
    icon: Cog,
    title: "Motori testati",
    text: "Ogni motore in catalogo viene controllato, testato e verificato dai nostri meccanici prima della messa in vendita.",
    img: "https://images.unsplash.com/photo-1552656967-7a0991a13906?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    span: "md:col-span-5",
  },
  {
    n: "04",
    icon: PackageSearch,
    title: "Vendita online",
    text: "Oltre 1.800 motori e ricambi disponibili nel nostro catalogo online, con spedizione in tutta Italia.",
    img: "https://images.unsplash.com/photo-1606337321936-02d1b1a4d5ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    span: "md:col-span-7",
  },
];

export default function Services() {
  return (
    <section id="chi-siamo" data-testid="services-section" className="relative border-b border-[#272A38] bg-[#0B0C10] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 max-w-2xl"
        >
          <p className="mono mb-3 text-xs uppercase tracking-[0.3em] text-[#F59E0B]">03 — Chi siamo</p>
          <h2 className="font-display text-5xl font-black uppercase leading-none tracking-tight text-[#F3F4F6] sm:text-6xl">
            Delta R.E.M. — <span className="text-stroke-amber italic">l'officina</span> dei motori
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#9CA3AF]">
            Da Cremona, diamo una seconda vita ai motori: recuperiamo, testiamo e rimettiamo
            in strada il cuore della tua auto. Autodemolizione, ricambi e motori usati
            selezionati uno a uno.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`service-chapter-${c.n}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden border border-[#272A38] bg-[#12141C] transition-colors duration-500 hover:border-[#F59E0B]/50 ${c.span}`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  loading="lazy"
                  className="spotlight-img h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#12141C] via-[#12141C]/40 to-transparent" />
                <span className="mono absolute right-4 top-4 text-[10px] uppercase tracking-[0.3em] text-[#F59E0B]">
                  Cap. {c.n}
                </span>
              </div>
              <div className="p-7">
                <c.icon className="mb-4 h-7 w-7 text-[#F59E0B]" strokeWidth={1.6} />
                <h3 className="font-display text-3xl font-black uppercase tracking-tight text-[#F3F4F6]">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#9CA3AF]">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
